
import {Utilities} from '../../shared/utilities/utilities.model';
import {DigitalSignSigner} from './digital-sign-signer.model';
import {DigitalSignDocument} from './digital-sign-document.model';
import {DigitalSignUtilities} from '../utilities/digital-sign-utilities.model';

export class DigitalSignCheckLastDossier {

	dossier_id: string;
	infocert_dossier_id: string;
	company_id: string;
	dossier_type: string;
	client_dossier_type: string;
	client_dossier_reference_type: string;
	client_dossier_reference_id: string;
	signers: DigitalSignSigners;
	documents: any;
	response: any;
	state: number;
	state_label: string;
	state_details: any;
	created_at: string;
	updated_at: string;
	
	constructor(type: string, model?: any) {
		if (!Utilities.isVoid(model)) {
			this.dossier_id = model.dossier_id;
			this.infocert_dossier_id = model.infocert_dossier_id;
			this.company_id = model.company_id;
			this.dossier_type = model.dossier_type;
			this.client_dossier_type = model.client_dossier_type;
			this.client_dossier_reference_type = model.client_dossier_reference_type;
			this.client_dossier_reference_id = model.client_dossier_reference_id;
			this.response = model.response;
			this.state = model.state;
			this.state_label = model.state_label;
			this.state_details = model.state_details;
			this.created_at = model.created_at;
			this.updated_at = model.created_at;
			if (type === DigitalSignUtilities.ORDERS_TYPE) {
				this.signers = new DeliveryDigitalSignSigners(model.signers);
				this.documents = new DeliveryDigitalSignDocuments(model.documents);
			}
			//TODO contractclosing
			this.signers = new DeliveryDigitalSignSigners(model.signers);
			this.documents = new DeliveryDigitalSignDocuments(model.documents);
		}
	}
}

export abstract class DigitalSignSigners {
	IR1: DigitalSignSigner;
	richiedente1: DigitalSignSigner;
}

export abstract class DigitalSignDocuments {
	DOC1: DigitalSignDocument;
	PTF: DigitalSignDocument;
	PTR: DigitalSignDocument;
}

export class DeliveryDigitalSignSigners extends DigitalSignSigners {

	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.IR1)) {
				this.IR1 = new DigitalSignSigner(model.IR1);
			}
			if (!Utilities.isVoid(model.richiedente1)) {
				this.richiedente1 = new DigitalSignSigner(model.richiedente1);
			}
		}
	}
}

export class DeliveryDigitalSignDocuments extends DigitalSignDocuments {
	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.DOC1)) {
				this.DOC1 = new DigitalSignDocument(model.DOC1);
			}
			if (!Utilities.isVoid(model.PTF)) {
				this.PTF = new DigitalSignDocument(model.PTF);
			}
			if (!Utilities.isVoid(model.PTR)) {
				this.PTR = new DigitalSignDocument(model.PTR);
			}
		}
	}
}
